/**
 * reloadFreshBypassingSW — the programmatic equivalent of Ctrl+Shift+R.
 *
 * Recovery path for stale-deploy chunk errors. When a new build ships while a
 * tab is open, the service worker keeps serving the OLD index.html (and its
 * precached shell), which references chunk hashes the server no longer has →
 * dynamic imports 404. A plain `location.reload()` does NOT fix this because the
 * reload is re-served the stale shell by that same service worker — the user
 * stays stuck on "Try again" until they manually hard-refresh.
 *
 * This unregisters the service worker(s) and clears the caches first, so the
 * reload fetches the current index.html + chunks straight from the network. The
 * SW re-registers on the fresh load, so offline support returns immediately.
 */
export function reloadFreshBypassingSW(): void {
  if (typeof window === 'undefined') return;
  void (async () => {
    try {
      if ('serviceWorker' in navigator) {
        const regs = await navigator.serviceWorker.getRegistrations();
        await Promise.all(regs.map((r) => r.unregister().catch(() => {})));
      }
      if (typeof caches !== 'undefined') {
        const keys = await caches.keys();
        await Promise.all(keys.map((k) => caches.delete(k).catch(() => {})));
      }
    } catch {
      /* best-effort — fall through to the reload regardless */
    }
    window.location.reload();
  })();
}
